import styles from './InputSection.module.css';
import { AssetInputSection } from './AssetInputSection';
import { CampaignMetadataInputSection } from './CampaignMetadataInputSection';

export const InputSection = () => {
  return (
    <section className={styles.container} role="region" aria-label="Campaign Input Sections">
      <div className={styles.content}>
        <AssetInputSection />
        <CampaignMetadataInputSection />
      </div>
    </section>
  );
};
